var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddReceiverIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20c-1.104 0-2.027-.913-1.716-1.973a7 7 0 0 1 13.432 0C22.028 19.087 21.105 20 20 20H10ZM20 7a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
    fill: "#FCB519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 17a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.333a4.667 4.667 0 1 0 0 9.334 4.667 4.667 0 0 0 0-9.334ZM1 17a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z",
    fill: "#FCB519"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.667 10.556 17 7 14.333v1.778H3.445v1.778H7v1.778Z",
    fill: "#FCB519"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddReceiverIconYellow);
export default __webpack_public_path__ + "static/media/add-receiver-icon-yellow.77a7f618b4be152b372d12778822a390.svg";
export { ForwardRef as ReactComponent };